<template>
  <v-autocomplete
    v-bind="$attrs"
    v-on="localListeners"
    v-model.number="localValue"
    :items="localItems"
    :search-input.sync="search"
    :loading="loading"
    :disabled="isDisabled"
    :clearable="isClearable"
    :error="!!errorMessages"
    :error-messages="errorMessages"
    :hide-details="!errorMessages"
    :readonly="readonly"
    :append-icon="`${readonly ? '' : '$vuetify.icons.dropdown'}`"
    :menu-props="menuProps"
  ></v-autocomplete>
</template>

<script>
export default {
  name: 'asyncAutocomplete',
  inheritAttrs: false,
  props: {
    value: {},
    model: {},
    disabled: {
      type: Boolean,
      default: () => false,
    },
    items: Array,
    readonly: {
      type: Boolean,
      default: () => false,
    },
    clearable: {
      type: Boolean,
      default: () => true,
    },
    menuProps: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      search: '',
      localItems: [],
      errorMessages: '',
    };
  },
  async mounted() {
    if (this.model) {
      await this.fetch();
    } else {
      this.localItems = this.items;
    }
  },
  watch: {
    'items': function(nArr) {
      this.localItems = nArr;
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    localListeners() {
      return {
        ...this.$listeners,
        focus: event => this.$emit('focus', event.target.value),
        blur: event => this.$emit('blur', event.target.value),
      };
    },
    isDisabled() {
      return this.loading || this.disabled;
    },
    isClearable() {
      return !this.clearable
        ? this.clearable
        : !this.isDisabled;
    },
    loading() {
      if (this.model) {
        const loading = this.model.namespace('loading');
        return this.$store.getters[loading];
      } else {
        return false;
      }
    },
  },
  methods: {
    async fetch() {
      try {
        await this.model.$fetch();
        this.localItems = this.model.all();
      } catch (e) {
        this.errorMessages = e;
      }
    },
  },
};
</script>
